import React, { forwardRef } from 'react';
import { styled } from '@linaria/react';

import { type ModalProps, ModalRef } from '@blocks/ui/modal';

import { Modal } from '../ui';
import { isBrowser } from '../utils';

import Auth, { type AuthProps } from '.';

const AccountModalContainer = styled.div`
  max-width: 320px;
`;

type AuthModalProps = Omit<ModalProps, 'children'> & AuthProps;

const AuthModal = forwardRef<ModalRef, AuthModalProps>(
  ({ domain, afterClose, title, ...rest }, ref) => {
    return (
      <>
        {isBrowser() && (
          <Modal
            ref={ref}
            title={title}
            afterClose={afterClose}
          >
            <AccountModalContainer>
              <Auth
                domain={domain}
                {...rest}
              />
            </AccountModalContainer>
          </Modal>
        )}
      </>
    );
  },
);

export default AuthModal;
